
import 'sass/conf/home/index.scss' // global style
import '@/module/utils/storageNameSpace' // 存储 命名空间

import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element'
import { sync } from 'vuex-router-sync'
import 'element-ui/lib/theme-chalk/index.css'
import '@/module/global'
import '@/module/utils/errorLog' // error log
import '@/module/permission' // permission control

sync(store, router)

Vue.use(ElementUI, { size: 'small' })

Vue.config.productionTip = false

new Vue({
  el: '#app-master',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/js/conf/home/index.js